export default "__VITE_ASSET__5c5867ed__"